import React, { useEffect } from 'react';
import { bem, classnames, use } from '../../lib';
import { Portal } from '../Portal';
import { ModalBody } from './ModalBody';
import { ModalFooter } from './ModalFooter';
import { ModalHeader } from './ModalHeader';
import { Spinner } from '../Spinner';
const getChildren = (children) => {
    let body, header, footer = null;
    let otherChildren = [];
    React.Children.forEach(children, (child) => {
        if (child) {
            switch (child.type) {
                case ModalHeader:
                    header = child;
                    break;
                case ModalBody:
                    body = child;
                    break;
                case ModalFooter:
                    footer = child;
                    break;
                default:
                    otherChildren.push(child);
                    break;
            }
        }
    });
    return { body, header, footer, otherChildren };
};
const ModalComponent = ({ children, open, className, size, loading }) => {
    const { body, header, footer, otherChildren } = getChildren(children);
    useEffect(() => {
        if (open && !document.body.classList.contains('modal-open')) {
            document.body.classList.add('modal-open');
        }
        else {
            document.body.classList.remove('modal-open');
        }
        return () => {
            document.body.classList.remove('modal-open');
        };
    });
    if (!open)
        return null;
    return (React.createElement(Portal, null,
        React.createElement("div", { className: classnames(bem('modal', '--visible'), className) },
            React.createElement("div", { className: classnames(bem('modal__dialog', use(size, `--${size}`))) },
                loading && React.createElement(Spinner, null),
                header,
                body || otherChildren,
                footer))));
};
/**
 * Modal component
 *
 * @visibleName Modal
 */
let Modal = /** @class */ (() => {
    class Modal extends React.Component {
        render() {
            return React.createElement(ModalComponent, Object.assign({}, this.props));
        }
    }
    Modal.Header = ModalHeader;
    Modal.Body = ModalBody;
    Modal.Footer = ModalFooter;
    return Modal;
})();
export { Modal };
//# sourceMappingURL=Modal.js.map